import { ApiResponse, getRequest } from "@/data/apiClient";

export interface ValidateCallbackUrlResponse {
  valid: boolean;
}

export const validateCallbackUrl = async (
  callbackUrl: string
): Promise<ApiResponse<ValidateCallbackUrlResponse>> =>
  getRequest("/validateCallbackUrl", { callbackUrl });
